function userSelectDirective() {
	return {
		scope : {
			user : '=',
			onUserChangeParam : '&?onUserChange',
			allowClearParam : '<?allowClear',
			filters : '<?'
		},
		restrict : 'E',
		replace : true,
		templateUrl : 'views/directives/userSelectDirective.html',
		controller : [ '$scope', 'userService', 'alertService', function($scope, userService, alertService) {
			var init = true;
			$scope.allowClear = false;
			$scope.availableUsers = [];

			if (!angular.isUndefined($scope.allowClearParam)) {
				if (typeof ($scope.allowClearParam) === "boolean") {
					$scope.allowClear = $scope.allowClearParam;
				}
			}

			$scope.searchUsers = function(query) {
				var filter = {};

				if ($scope.filters)
					filter = $scope.filters;

				filter.name = query;
				filter.username = query;
				filter.email = query;

				userService.searchUsers(filter).then(function(response) {
					$scope.availableUsers = response.getData().results;
					// se hace solo la primera vez y es por si solo se conoce el
					// id del usuatio que se quiere seleccionar
					if ($scope.user.id && init) {
						init = false;
						var sel = $scope.availableUsers.find(function(c) {
							return c.id == $scope.user.id;
						});
						if (sel) {
							$scope.user.selected = sel;
						} else {
							userService.loadUser($scope.user.id).then(function(response) {
								$scope.user.selected = response.getData();
							});
						}
						$scope.user.id = undefined;
					}
				}, function(response) {
					// on error
				});
			};

			$scope.onUserChange = function(user) {
				if ($scope.onUserChangeParam)
					$scope.onUserChangeParam({
						user : user
					});
			}

		} ],
		link : function(scope, iElement, iAttrs) {

		}
	};
};

module.directive('userSelect', [ userSelectDirective ]);